import clsx from "clsx";
import React from "react";

const RunningStrategyCard = ({ stopped }: { stopped?: boolean }) => {
  const lastChecked = new Date(Date.now() - 43 * 1000);
  const statusColor = stopped ? "red-400" : "green-400";
  const statusText = stopped ? "Stopped" : "Running";

  return (
    <div className="flex items-center gap-2 px-2 py-1 rounded-md bg-transparent text-white text-xs">
      <div className="leading-tight">
        <div className="flex items-center gap-2 ">
          <div className="relative ">
            {!stopped && (
              <div
                className={clsx(
                  `absolute top-0 bottom-0 m-auto left-0 w-2 h-2 rounded-full animate-ping opacity-75`,
                  stopped ? " bg-red-400" : "bg-green-400"
                )}
              ></div>
            )}
            <div
              className={clsx(
                `relative w-2 h-2  top-0 bottom-0 m-auto rounded-full`,
                stopped ? " bg-red-400" : "bg-green-400"
              )}
            ></div>
          </div>
          <p className="font-medium">{statusText}</p>
        </div>
        <p className="text-[10px] text-gray-400">
          Last checked -{" "}
          {lastChecked.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "long",
          })}
          , {lastChecked.toUTCString().split(" ")[4]} UTC
        </p>
      </div>
    </div>
  );
};

export default RunningStrategyCard;
